import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * AI Disclaimer Component
 * Displays important legal disclaimer for AI-generated educational content
 * Must be shown prominently with all AI analysis features
 */
const AIDisclaimer = () => {
  return (
    <div className="bg-amber-50 border-l-4 border-amber-400 p-6 mb-6 rounded-r-lg shadow-sm">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <AlertTriangle className="h-6 w-6 text-amber-600" />
        </div>
        <div className="ml-4">
          <h3 className="text-lg font-semibold text-amber-900 mb-3">
            Important: For Educational Use Only
          </h3>
          <div className="text-sm text-amber-800 space-y-2">
            <p>
              This report is generated by artificial intelligence (AI) and is for{' '}
              <strong>educational and informational purposes only</strong>. It is{' '}
              <strong>not financial, investment, legal, or tax advice</strong>.
            </p>
            <p>
              The analysis is based on general market principles and a high-level, anonymized
              summary of your portfolio. It does not consider your complete personal financial
              situation, risk tolerance, or specific investment goals.
            </p>
            <p>
              <strong>Do not base any investment decisions</strong> (such as buying, selling,
              or holding any asset) on this report. All investments carry risk, and past
              performance is not indicative of future results.
            </p>
            <p className="font-semibold mt-3">
              PlanLens is not a regulated financial advisor. For personalized financial advice,
              please consult with a qualified, regulated financial professional.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIDisclaimer;
